// extracted by mini-css-extract-plugin
module.exports = {"icon":"AppleButton_icon__kD9TB"};